module.exports = __webpack_public_path__ + "aryeo-wordmark-1a3e715638f915b79af7150e0d85b45f.webp";